import React from "react";
import { useTheme } from "./theme";

export default function Footer() {
  const { theme } = useTheme();
  const palette = theme.palette;

  return (
    <footer
      style={{
        textAlign: "center",
        padding: "2rem 1rem",
        background: palette.background,
        borderTop: `1px solid ${palette.border}`,
        color: palette.textMuted,
        marginTop: "auto",
      }}
    >
      © {new Date().getFullYear()} LaunchSafely. All rights reserved.
    </footer>
  );
}
